import type { GenericPostDetail } from '@/features/posts/types/posts';
import { dayjs } from '@/time';

export type PostDayGroup = {
  dayKey: string;
  dayStart: number;
  posts: GenericPostDetail[];
};

export const groupPostsByDay = (
  posts: GenericPostDetail[] = []
): PostDayGroup[] => {
  const groups: PostDayGroup[] = [];
  for (const post of posts) {
    if (post.created === undefined) {
      continue;
    }
    const dayStart = dayjs(post.created).startOf('day').valueOf();
    const dayKey = dayStart.toString();
    const lastGroup = groups.at(-1);
    if (lastGroup && lastGroup.dayKey === dayKey) {
      lastGroup.posts.push(post);
      continue;
    }
    groups.push({ dayKey, dayStart, posts: [post] });
  }
  return groups;
};
